import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Battery_card_listing = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const storedUser = localStorage.getItem("username");
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
      const [currentPage, setCurrentPage] = useState(1);
      const [itemsPerPage] = useState(10);
      const [searchTerm, setSearchTerm] = useState("");

      const canView  = hasPermission("Delivery Note", "view");
      const canEntry = hasPermission("Delivery Note", "entry");
                

 useEffect(() => {
  setLoading(true);
  axios.get("https://rfs2.infraconsoft.net.in/api/deliveryNote_list")
    .then((response) => {
      const fullList = response.data.deliverylist || [];

      // Filter only unique del_no entries
      const uniqueList = fullList.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.del_no === item.del_no)
      );

      setData(uniqueList);
      setFilteredData(uniqueList);
    })
    .catch((error) => {
      console.error("Error fetching vehicles:", error);
    })
    .finally(() => {
      setLoading(false);
    });
}, []);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
  
    if (term === "") {
      setFilteredData(data);
      return;
    }
  
    const filtered = data.filter((item) =>
      (String(item.del_no || "").toLowerCase().includes(term))
    );
  
    setFilteredData(filtered);
  };
 

 if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Delivery Note Details</h2>
          <Time />
        </section>

{canEntry && (
        <div className="add-new-container">
            <Link to={`/inventory/deliveryNote_add_in`}><button className="add-new-btn"><i className="fa-solid fa-plus"></i> Add New</button></Link>
        </div>
)}

        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by Del No" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Delivery No</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="6" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
        <td><Link target="_blank" to={`/inventory/deliverynote_detailsView_in/${item.del_no}`}>{item.del_no}</Link></td>
        <td>{item.del_date ? new Date(item.del_date).toLocaleDateString('en-GB') : "N/A"}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>1</button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}> Next</button>
        </div>
      </div>
    </div>
  );
};

export default Battery_card_listing;
